import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import "@/i18n";
import App from "@/App";
import * as serviceWorkerRegistration from "@/serviceWorkerRegistration";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Abilita la PWA (installabilita + caching offline base).
serviceWorkerRegistration.register();

// Disabilita lo zoom dell'app (pinch, gesture iOS, ctrl/cmd + rotellina o +/-).
(function disableZoom() {
  ['gesturestart', 'gesturechange', 'gestureend'].forEach((evt) =>
    document.addEventListener(evt, (e) => e.preventDefault(), { passive: false })
  );
  document.addEventListener(
    'touchmove',
    (e) => { if (e.touches && e.touches.length > 1) e.preventDefault(); },
    { passive: false }
  );
  document.addEventListener(
    'wheel',
    (e) => { if (e.ctrlKey) e.preventDefault(); },
    { passive: false }
  );
  document.addEventListener('keydown', (e) => {
    if ((e.ctrlKey || e.metaKey) && ['+', '-', '=', '0'].includes(e.key)) e.preventDefault();
  });
})();

